import BDragDropUploadForm from "./BDragDropUploadForm";

export default class BDragDropUploadFile
{
	constructor (el)
	{
		this.el = el;
	}

	static className = () => `drag-drop-upload__file`;
	static selector = () => `.${this.className()}`;

	static initialize()
	{
		this.addEventListeners();
	}

	setProgress(event)
	{
		const progress = event.position / event.totalSize;
		const progressBar = this.el.querySelector(`.drag-drop-upload__progress-bar`);
		progressBar.style.width = `${progress * 100}%`;
	}

	setFromResponse(response)
	{
		this.el.classList.add(`${BDragDropUploadFile.className()}--complete`);
		this.el.dataset.storageFileId = response.data[0].id;
		this.el.querySelector(`${BDragDropUploadForm.selector()}__file-ids-input`).value = response.data[0].id;
		const thumb = response.data[0].images?.SQUARE_THUMBNAIL;
		const thumbUrl = thumb && typeof thumb === "object" && thumb.url != null ? thumb.url : thumb;
		if (thumbUrl) {
			this.el.querySelector(`img`).src = thumbUrl;
		}
	}

	remove()
	{
		this.el.remove();
	}
}
